import { ChakraProvider } from '@chakra-ui/react';

import { Calendar, EventDetailModal } from './components/calendar';
import {
	CalendarSettingsProvider,
	FiltersProvider,
	ModalProvider,
	CalendarViewProvider,
	EventPositionProvider,
	ContainerWidthProvider,
	CalendarDataProvider,
} from '../src/lib';
import { theme } from './theme';

import './style.scss';

const CalendarPlus: React.FunctionComponent = () => {
	return (
		<ChakraProvider theme={theme}>
			<CalendarSettingsProvider>
				<CalendarDataProvider>
					<FiltersProvider>
						<CalendarViewProvider>
							<ModalProvider>
								<EventPositionProvider>
									<ContainerWidthProvider>
										<Calendar />
									</ContainerWidthProvider>
									<EventDetailModal />
								</EventPositionProvider>
							</ModalProvider>
						</CalendarViewProvider>
					</FiltersProvider>
				</CalendarDataProvider>
			</CalendarSettingsProvider>
		</ChakraProvider>
	);
};

export default CalendarPlus;
